<template>
  <div
    class="content has-text-centered"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >
    <table
      id="tas"
      class="table is-striped is-responsive"
      :class="{'farsi-table': Language == 'fa' || Language == 'ar'}"
    >
      <thead>
        <tr>
          <th>{{ $t('platform').tUpper() }}</th>
          <th colspan="2">{{ $t('account').tUpper() }}</th>
          <th>{{ $t('type').tUpper() }}</th>
          <th>{{ $t('account_type').tUpper() }}</th>
          <th>{{ $t('currency').tUpper() }}</th>
          <th>{{ $t('balance').tUpper() }}</th>
          <th>{{ $t('equity').tUpper() }}</th>
          <th>{{ $t('leverage').tUpper() }}</th>
          <!--th>{{ $t("bonus").tUpper() }}</th-->
          <th>{{ $t('deposit').tUpper() }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="ta in User.TA"
          v-if="ta.platform != 'transfer'"
          :key="ta.external_id"
          :class="{ 'archived' : ta.account_type === ''}"
        >
          <td>
            <span class="is-hidden-tablet has-text-weight-bold">{{ $t('platform').tTitle() }}:</span>
            <img :src="platformImages[ta.platform]" />
          </td>
          <td>
            <span class="is-hidden-tablet has-text-weight-bold">{{ $t('account').tTitle() }}:</span>
            <span v-if="ta.account_type_identifier === 'pamm-investor' && ta.platform === 'mt4'">
              <a
                class="has-text-weight-bold custom-linked-taid"
                target="_blank"
                href="https://pamm.eurotrader.com"
              >{{ ta.external_id }}</a>
            </span>
            <span v-else-if="ta.account_type_identifier === 'pamm-investor' && ta.platform === 'mt5'">
              <a
                class="has-text-weight-bold custom-linked-taid"
                target="_blank"
                href="https://pamm-mt5.eurotrader.com"
              >{{ ta.external_id }}</a>
            </span>
            <span v-else>
              {{ ta.external_id }}
            </span>
          </td>
          <td>
            <!-- <router-link
              v-if="ta.type == 'live' && ta.platform === 'mt4' && ta.transfer_locked == 'no' && ta.account_type !== '' && ta.account_type_identifier !== 'pamm-investor'"
              class="button is-primary is-fullwidth"
              :to="'/' + Language + '/mt4-web-client'"
              target="_blank"
              v-tooltip="'Launch web client'"
            >{{ $t('trade').tUpper() }}</router-link> -->
            <router-link
              v-if="ta.type == 'live' && ta.platform === 'mt5' && ta.transfer_locked == 'no' && ta.account_type !== '' && ta.account_type_identifier !== 'pamm-investor'"
              class="button is-primary is-fullwidth"
              :to="'/' + Language + '/mt5-web-client'"
              target="_blank"
              v-tooltip="'Launch web client'"
            >{{ $t('trade').tUpper() }}</router-link>
          </td>
          <td>
            <span class="
              is-hidden-tablet
              has-text-weight-bold">{{ $t('type').tTitle() }}:</span>
            {{ ta.type.tUpper() }}
          </td>
          <td>
            <span class="is-hidden-tablet has-text-weight-bold">{{ $t('account_type').tTitle() }}:</span>
            {{ ta.account_type === ''? 'ARCHIVED': ta.account_type.tUpper() }}
            <span v-if="ta.ib_campaign_original_group_requested">
              - S
              <i
                class="fa fa-info-circle has-cursor-pointer"
                v-tooltip="'Account type is applicable depending on the referral campaign'"
              ></i>
            </span>
          </td>
          <td>
            <span class="is-hidden-tablet has-text-weight-bold">{{ $t('currency').tTitle() }}:</span>
            {{ ta.currency }}
          </td>
          <td>
            <span class="is-hidden-tablet has-text-weight-bold">{{ $t('balance').tTitle() }}:</span>
            {{ $formatMoney(ta.balance, currencies[ta.currency].symbol) }}
          </td>
          <td>
            <span class="is-hidden-tablet has-text-weight-bold">{{ $t('equity').tTitle() }}:</span>
            {{ $formatMoney(ta.equity, currencies[ta.currency].symbol) }}
          </td>
          <td>
            <span class="is-hidden-tablet has-text-weight-bold">{{ $t('leverage').tTitle() }}:</span>
            {{ ta.leverage }}
          </td>
          <!--td>
            <span class="is-hidden-tablet has-text-weight-bold">{{ $t("bonus").tTitle() }}:</span>
            {{getTABonus(ta.external_id)}}
          </td-->
          <td class="is-mobile-full">
            <!-- <span class="is-hidden-tablet has-text-weight-bold">{{ $t("deposit").tTitle() }}:</span> -->
            <button
              v-if="ta.type == 'live' && ta.transfer_locked == 'no' && ta.account_type !== ''"
              class="button is-primary is-fullwidth"
              @click="preSelecteDepositTA(ta)"
            >{{ $t('deposit').tUpper() }}</button>
            <button
              v-if="ta.transfer_locked == 'yes'"
              class="button is-primary is-fullwidth"
              @click="openTransferBackModal(ta.external_id, ta.equity)"
            >{{ $t('transfer').tUpper() }}</button>
          </td>
          <td class="action-icon">
            <span
              class="icon settings"
              @click="toggleSettingsActive"
            >
              <i class="fa fa-cog"></i>
              <nav class="panel settings animated fadeIn">
                <a
                  v-if="ta.account_type!== ''"
                  class="panel-block is-active"
                  @click=";(changeTAPassword.TAID = ta.external_id), (changeTAPassword.modalActive = true)"
                >
                  <span class="panel-icon">
                    <i class="fa fa-unlock-alt"></i>
                  </span>
                  {{ $t('change_password').tUpper() }}
                </a>

                <!-- <a class="panel-block is-active" @click="preSelecteDepositTA(ta)" v-if="ta.type == 'live' && ta.transfer_locked == 'no'">
									<span class="panel-icon">
										<i class="fa fa-credit-card"></i>
									</span>{{ $t("deposit").tUpper() }}
                </a>-->

                <a
                  class="panel-block is-active"
                  @click="openTransferBackModal(ta.external_id, ta.equity)"
                  v-if="ta.type == 'live' && ta.transfer_locked == 'yes'"
                >
                  <span class="panel-icon">
                    <i class="fa fa-credit-card"></i>
                  </span>
                  {{ $t('transfer').tUpper() }}
                </a>

                <a
                  class="panel-block is-active"
                  href="download"
                >
                  <span class="panel-icon">
                    <i class="fa fa-cloud-download"></i>
                  </span>
                  {{ $t('download').tUpper() }}
                </a>
                <a
                  class="panel-block is-active"
                  @click="openTradesModal(ta.external_id, ta.platform, ta.type)"
                >
                  <span class="panel-icon">
                    <i class="fa fa-list-alt"></i>
                  </span>
                  {{ $t('view_trades').tUpper() }}
                </a>
              </nav>
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="modal"
      :class="{ 'is-active': transferBack.modalActive }"
      id="transferBackModal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t('transfer_back_to_my_local_depositor').tUpper() }}</p>
          <button
            class="delete"
            @click="transferBack.modalActive = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <form
            @submit.prevent
            data-vv-scope="form-transfer"
          >
            <div class="field">
              <label class="label">{{ $t('amount').tUpper() }}</label>
              <p class="control has-icons-left has-icons-right">
                <input
                  v-validate="'required|min_value:1'"
                  :class="{ input: true, 'is-danger': errors.has('form-transfer.amount') }"
                  id="amount"
                  name="amount"
                  type="number"
                  v-model="transferBack.amount"
                />
                <span
                  v-show="errors.has('form-transfer.amount')"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                  id="transferError"
                  class="help is-danger animated"
                >{{ errors.first('form-transfer.amount') }}</span>
                <span class="icon is-small is-right">
                  <i class="fa fa-check"></i>
                </span>
              </p>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot reverse">
          <a
            class="button is-success"
            @click="executeTransferBack()"
          >{{ $t('transfer_back').tUpper() }}</a>
          <a
            class="button"
            @click="transferBack.modalActive = false"
          >{{ $t('cancel').tTitle() }}</a>
        </footer>
      </div>
    </div>

    <div
      class="modal"
      :class="{ 'is-active': changeTAPassword.modalActive }"
      id="changeTAPassword"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t('change_password').tUpper() }}</p>
          <button
            class="delete"
            @click="changeTAPassword.modalActive = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <form
            @submit.prevent
            data-vv-scope="form-changePassword"
            :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
          >
            <div class="field">
              <label
                class="label"
                for="newPassword"
              >{{ $t('new_password').tTitle() }}</label>
              <p class="control has-icons-left has-icons-right">
                <input
                  v-validate="'required|strong-password|confirmed:newPasswordConfirm'"
                  :class="{ input: true, 'is-danger': errors.has('form-changePassword.newPassword') }"
                  name="newPassword"
                  type="password"
                  :data-vv-as="$t('new_password').tTitle()"
                  :placeholder="$t('new_password').tTitle()"
                  v-model="changeTAPassword.new"
                />
                <span
                  v-show="errors.has('form-changePassword.newPassword')"
                  class="help is-danger"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >{{ errors.first('form-changePassword.newPassword') }}</span>
                <span
                  class="icon is-small"
                  :class="{'is-right': Language == 'fa' || Language == 'ar', 'is-left': Language != 'fa' && Language != 'ar'}"
                >
                  <i class="fa fa-lock"></i>
                </span>
                <span
                  class="icon is-small"
                  :class="{'is-left': Language == 'fa' || Language == 'ar', 'is-right': Language != 'fa' && Language != 'ar'}"
                >
                  <i class="fa fa-check"></i>
                </span>
              </p>
            </div>
            <div class="field">
              <label
                class="label"
                for="newPasswordConfirm"
              >{{ $t('confirm_new_password').tTitle() }}</label>
              <p class="control has-icons-left has-icons-right">
                <input
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('form-changePassword.newPasswordConfirm') }"
                  name="newPasswordConfirm"
                  type="password"
                  :data-vv-as="$t('confirm_new_password').tTitle()"
                  :placeholder="$t('confirm_new_password').tTitle()"
                  v-model="changeTAPassword.newConfirm"
                  ref="newPasswordConfirm"
                />
                <span
                  v-show="errors.has('form-changePassword.newPasswordConfirm')"
                  class="help is-danger"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >{{ errors.first('form-changePassword.newPasswordConfirm') }}</span>
                <span
                  class="icon is-small"
                  :class="{'is-right': Language == 'fa' || Language == 'ar', 'is-left': Language != 'fa' && Language != 'ar'}"
                >
                  <i class="fa fa-lock"></i>
                </span>
                <span
                  class="icon is-small"
                  :class="{'is-left': Language == 'fa' || Language == 'ar', 'is-right': Language != 'fa' && Language != 'ar'}"
                >
                  <i class="fa fa-check"></i>
                </span>
              </p>
            </div>
          </form>
        </section>
        <footer
          class="modal-card-foot reverse"
          :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
        >
          <a
            class="button is-success"
            @click="changeTAPasswordReq()"
          >{{ $t('change_password').tUpper() }}</a>
          <a
            :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
            class="button"
            @click="closeChangePasswordModal()"
          >{{ $t('cancel').tTitle() }}</a>
        </footer>
      </div>
    </div>

    <div
      class="modal"
      :class="{ 'is-active': tradesModalTAID > 0 }"
    >
      <div
        class="modal-background"
        @click="openTradesModal(0, '', '')"
      ></div>
      <div class="modal-card">
        <header
          class="modal-card-head"
          :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
        >
          <p class="modal-card-title">{{$t('view_trades')}}: {{ tradesModalTAID }}</p>
          <button
            class="delete"
            @click="openTradesModal(0, '', '')"
          ></button>
        </header>
        <section class="modal-card-body">
          <div
            class="tabs is-centered is-boxed"
            :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
          >
            <ul>
              <li
                :class="{ 'is-active': tabsActive == 'openTrades' }"
                @click="tabsActive = 'openTrades'"
              >
                <a>
                  <span>{{$t('open_trades').tUpper()}}</span>
                </a>
              </li>
              <li
                :class="{ 'is-active': tabsActive == 'tradeHistory' }"
                @click="tabsActive = 'tradeHistory'"
              >
                <a>
                  <span>{{$t('trade_history').tUpper()}}</span>
                </a>
              </li>
            </ul>
          </div>
          <div
            class="relative"
            :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
          >
            <div id="dateRangeHolder">
              <div :class="{'display-inline': Language == 'fa' || Language == 'ar'}">
                <div
                  class="datePickerLabel"
                  :class="{'float-right': Language == 'fa' || Language == 'ar'}"
                >{{$t('date_from').tCapitalizeFirstLetter()}}</div>
                <div class="datepickerContainer">
                  <datepicker
                    v-model="dateFrom"
                    placeholder="YYYY-MM-DD"
                    :config="{ dateFormat: 'Y-m-d', static: true }"
                  ></datepicker>
                </div>
              </div>
              <div :class="{'display-inline direction-rtl': Language == 'fa' || Language == 'ar'}">
                <div
                  class="datePickerLabel"
                  :class="{'float-right': Language == 'fa' || Language == 'ar'}"
                >{{$t('date_until').tCapitalizeFirstLetter()}}</div>
                <div class="datepickerContainer">
                  <datepicker
                    v-model="dateTo"
                    placeholder="YYYY-MM-DD"
                    :config="{ dateFormat: 'Y-m-d', static: true }"
                  ></datepicker>
                </div>
              </div>
              <div
                class="block"
                :class="{'search-block': Language == 'fa' || Language == 'ar'}"
              >
                <a
                  class="button is-red"
                  @click="getTradeHistory()"
                >{{$t('search')}}</a>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>

          <table
            class="table is-striped is-responsive tradesTable"
            :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
          >
            <thead>
              <tr>
                <th :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{$t("trade_no").tUpper()}}</th>
                <th :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{$t("datetime").tUpper()}}</th>
                <th :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{$t("type").tUpper()}}</th>
                <th>{{$t("symbol").tUpper()}}</th>
                <th class="has-text-right">{{$t("volume").tUpper()}}</th>
                <th class="has-text-right">{{$t("open_price").tUpper()}}</th>
                <th class="has-text-right">{{$t("close_price").tUpper()}}</th>
                <th class="has-text-right">{{$t("swap").tUpper()}}</th>
                <th class="has-text-right">{{$t("commission").tUpper()}}</th>
                <th class="has-text-right">{{$t("p_l").tUpper()}}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="trade in trades"
                :key="trade.login"
              >
                <td>
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("trade_no").tUpper()}}:</span>
                  {{ trade.order }}
                </td>
                <td>
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("datetime").tUpper()}}:</span>
                  {{ tabsActive == 'openTrades' ? trade.open_time_formatted : trade.close_time_formatted }}
                </td>
                <td>
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("type").tUpper()}}:</span>
                  {{ trade.cmd == '0' ? $t("buy").tUpper() : trade.cmd == '1' ? $t("sell").tUpper() : $t("balance").tUpper() }}
                </td>
                <td>
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("symbol").tUpper()}}:</span>
                  {{ $simplePair(trade.symbol) }}
                </td>
                <td class="has-text-right">
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("volume").tUpper()}}:</span>
                  {{ trade.true_volume }}
                </td>
                <td class="has-text-right">
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("open_price").tUpper()}}:</span>
                  {{ trade.open_price }}
                </td>
                <td class="has-text-right">
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("close_price").tUpper()}}:</span>
                  {{ trade.close_price }}
                </td>
                <td class="has-text-right">
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("swap").tUpper()}}:</span>
                  {{ trade.storage }}
                </td>
                <td class="has-text-right">
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("commission").tUpper()}}:</span>
                  {{ trade.commission }}
                </td>
                <td class="has-text-right">
                  <span class="is-hidden-tablet has-text-weight-bold">{{$t("p_l").tUpper()}}:</span>
                  {{ trade.true_profit }}
                </td>
              </tr>
              <tr>
                <td
                  colspan="7"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >{{$t("sums").tUpper()}}</td>
                <td class="has-text-right">{{ sums.storage }}</td>
                <td class="has-text-right">{{ sums.commission }}</td>
                <td class="has-text-right">{{ sums.true_profit }}</td>
              </tr>
              <tr>
                <td
                  colspan="9"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >{{$t("net_total").tUpper()}}</td>
                <td class="has-text-right">{{ sums.net_total }}</td>
              </tr>
            </tbody>
          </table>
        </section>
        <footer class="modal-card-foot"></footer>
      </div>
    </div>

    <error-modal></error-modal>
  </div>
</template>

<script>
// import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../app'
import config from '../../config'
import api from '../../api'
import moment from 'moment'
import Datepicker from 'vue-bulma-datepicker'
import ErrorModal from '../../components/ErrorModal'

export default {
  props: ['platformImages'],
  data() {
    return {
      active: false,
      name: 'Account list',
      tabsActive: 'openTrades',
      dateFrom: moment(moment().subtract(6, 'months')).format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD'),
      prevFrom: moment(moment().subtract(6, 'months')).format('YYYY-MM-DD'),
      prevTo: moment().format('YYYY-MM-DD'),
      tradesModalTAID: 0,
      tradesModalPlatform: '',
      tradesModalType: '',
      trades: [],
      prevTrades: [],
      sums: [],
      prevSums: [],
      Bonuses: [],
      translations: {
        text: {
          currentPassword: this.$t('current_password').tTitle(),
          newPassword: this.$t('new_password').tTitle(),
          newPasswordConfirm: this.$t('confirm_new_password').tTitle(),
        },
      },
      changeTAPassword: {
        modalActive: false,
        new: '',
        newConfirm: '',
        TAID: null,
      },
      transferBack: {
        modalActive: false,
        amount: 0,
        equity: 0,
        TAID: 0,
      },
      currencies: config.currencies,
    }
  },
  components: {
    Datepicker,
    ErrorModal,
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
      Requests: 'requests/all',
      logoLoaderActive: 'logoLoader/active',
    }),
  },
  watch: {
    tabsActive() {
      this.changeTab()
    },
    'User.info'(u) {
      if (u.ID) {
        api.GetTradingAccounts().then(t => {
          this.getUserBonuses()
        })
      }
    },
  },
  mounted() {
    this.$bus.$on('AppClick', this.onAppClick)
    // load TA
    if (typeof this.User.info.ID !== 'undefined') {
      this['logoLoader/set'](true)
      api.GetTradingAccounts().then(t => {
        this.getUserBonuses()
        this['logoLoader/set'](false)
      })
    }
  },
  beforeDestroy() {
    this.$bus.$off('AppClick', this.onAppClick)
    // this.$parent.$el.removeEventListener('click', this.onAppClick)
  },
  methods: {
    executeTransferBack() {
      this['logoLoader/set'](true)
      this.$validator
        .validateAll('form-transfer')
        .then(result => {
          if (!result) {
            document.getElementById('transferError').classList.add('shakeSubtle')
            setTimeout(function () {
              document.getElementById('transferError').classList.remove('shakeSubtle')
            }, 1200)
            this['logoLoader/set'](false)
          } else {
            service
              .post('/finance/external-transfer/transfer-back', {
                fromTA: this.transferBack.TAID,
                userID: this.User.info.ID,
                amount: this.transferBack.amount,
              })
              .then(response => {
                this.transferBack.TAID = 0
                this.transferBack.modalActive = false
                this.$toasted.success(this.$t('external_transfer_processed_successfully').tTitle())
                this['logoLoader/set'](false)
              })
              .catch(() => {
                this.transferBack.TAID = 0
                this.transferBack.modalActive = false
                this['errorModal/set']({ active: true, text: this.$t('error_request_failed').tTitle() })
                this['logoLoader/set'](false)
              })
          }
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    openTransferBackModal(TAID, equity) {
      this.transferBack.modalActive = true
      this.transferBack.TAID = TAID
      this.transferBack.equity = equity
    },
    changeTAPasswordReq() {
      // validate
      this['logoLoader/set'](true)
      this.$validator
        .validateAll('form-changePassword')
        .then(result => {
          if (!result) {
            this['logoLoader/set'](false)
          } else {
            service
              .post('/ta/change-password', {
                TAID: this.changeTAPassword.TAID,
                userID: this.User.info.ID,
                password: this.changeTAPassword.new,
                passwordConfirm: this.changeTAPassword.newConfirm,
              })
              .then(response => {
                this.closeChangePasswordModal()
                this['logoLoader/set'](false)

                this.$toasted.success('Success')
              })
              .catch(error => {
                this.closeChangePasswordModal()
                this['logoLoader/set'](false)

                if (typeof error.response.data !== 'undefined') {
                  this.$toasted.error(error.response.data.detail + '<span class="error-id">' + error.response.data.id + '</span>', { duration: 10000 })
                }
              })
          }
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    getUserBonuses() {
      service.get('/bonus/' + this.User.info.ID).then(response => {
        if (response.data) {
          if (response.data.Bonuses) {
            this.Bonuses = response.data.Bonuses
          }
        }
      })
    },
    getTABonus(ta) {
      for (let i = 0; i < this.Bonuses.length; i++) {
        if (this.Bonuses[i].trading_account === ta) {
          return this.Bonuses[i].bonusAmount
        }
      }
      return 0
    },
    preSelecteDepositTA(TA) {
      // might want to pre-select psp here
      this.$router.push('/' + this.Language + '/finance/deposit')
    },
    changeTab() {
      let tempFrom, tempTo, tempTrades, tempSums

      tempFrom = this.dateFrom
      tempTo = this.dateTo
      tempTrades = this.trades
      tempSums = this.sums

      this.dateFrom = this.prevFrom
      this.dateTo = this.prevTo
      this.trades = this.prevTrades
      this.sums = this.prevSums

      this.prevFrom = tempFrom
      this.prevTo = tempTo
      this.prevTrades = tempTrades
      this.prevSums = tempSums
    },
    timestampToDate(t) {
      return moment.utc(moment.unix(t)).format('YYYY-MM-DD HH:mm')
    },
    getTradeHistory() {
      this['logoLoader/set'](true)

      service
        .post('/ta/pamm-trades', {
          userID: this.User.info.ID,
          TAID: this.tradesModalTAID,
          platform: this.tradesModalPlatform,
          type: this.tradesModalType,
          dateFrom: this.dateFrom + ' 00:00:00',
          dateTo: this.dateTo + ' 23:59:59',
          tradesType: this.tabsActive,
        })
        .then(response => {
          this.trades = response.data.pammTrades

          this.sums.storage = 0
          this.sums.commission = 0
          this.sums.true_profit = 0
          for (let i = 0; i < this.trades.length; i++) {
            this.sums.storage += this.trades[i].storage
            this.sums.commission += this.trades[i].commission
            this.sums.true_profit += this.trades[i].true_profit
          }

          this.sums.net_total = this.sums.true_profit + this.sums.storage + this.sums.commission

          this.sums.storage = Math.round(this.sums.storage * 100) / 100
          this.sums.commission = Math.round(this.sums.commission * 100) / 100
          this.sums.true_profit = Math.round(this.sums.true_profit * 100) / 100
          this.sums.net_total = Math.round(this.sums.net_total * 100) / 100
          this['logoLoader/set'](false)
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    openTradesModal(TAID, platform, type) {
      this.tradesModalTAID = TAID
      this.tradesModalPlatform = platform
      this.tradesModalType = type

      this.trades = []
      this.prevTrades = []

      this.sums = []
      this.prevSums = []

      this.dateFrom = moment(moment().subtract(6, 'months')).format('YYYY-MM-DD')
      this.dateTo = moment().format('YYYY-MM-DD')
      this.prevFrom = moment(moment().subtract(6, 'months')).format('YYYY-MM-DD')
      this.prevTo = moment().format('YYYY-MM-DD')
    },
    imagePath(platform) {
      return require('../../assets/img/logos/' + platform + '-small.png')
    },
    toggleSettingsActive(e) {
      // rest of settings
      let el = document.getElementsByClassName('settings')
      for (let i = 0; i < el.length; i++) {
        if (el[i] !== e.target.parentElement) {
          el[i].classList.remove('is-active')
        }
      }
      // row
      let par = e.target.parentElement
      while (par.tagName !== 'TR') {
        par = par.parentElement
        if (par === null) {
          break
        }
      }
      // rest of rows
      let trs = document.getElementById('tas').getElementsByTagName('tr')
      for (let i = 0; i < trs.length; i++) {
        if (trs[i] !== par) {
          trs[i].classList.remove('selected')
        }
      }
      // target
      e.target.parentElement.classList.toggle('is-active')

      // todo: is-selected in bulma 0.4.2
      par.classList.toggle('selected')
    },
    onAppClick(e) {
      if (!e.target.parentElement.classList.contains('settings')) {
        let trs = document.getElementById('tas').getElementsByTagName('tr')
        for (let i = 0; i < trs.length; i++) {
          trs[i].classList.remove('selected')
        }
        let el = document.getElementsByClassName('settings')
        for (let i = 0; i < el.length; i++) {
          el[i].classList.remove('is-active')
        }
      }
    },
    closeChangePasswordModal() {
      this.changeTAPassword.modalActive = false
      this.changeTAPassword.TAID = null
      this.changeTAPassword.new = ''
      this.changeTAPassword.newConfirm = ''
      this.errors.clear()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    ...mapActions(['logoLoader/set', 'errorModal/set']),
  },
}
</script>

<style lang="scss">
// @import '~bulma';
@import '~bulma/sass/utilities/initial-variables';
@import '../../assets/css/variables';

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#changeTAPassword.modal {
  .modal-card {
    max-width: 650px;
  }
  .modal-card-body {
    flex-grow: 0;
    -webkit-flex-grow: 0;
  }
}

#transferBackModal.modal {
  .modal-card {
    max-width: 650px;
  }
  .modal-card-body {
    flex-grow: 0;
    -webkit-flex-grow: 0;
  }
}
table.farsi-table {
  tbody {
    tr {
      position: relative;

      @media screen and (min-width: $tablet) {
        &:hover {
          td:first-of-type:before,
          td:last-of-type:before {
            content: '';
            display: block;
            position: absolute;
            left: 135px !important;
            top: 0;
            width: 5px;
            height: 100%;
            background-color: #ff0000;
          }

          td:last-of-type:before {
            right: 95px !important;
            left: auto;
          }
        }
      }
    }
  }
}
table#tas {
  tbody {
    tr {
      position: relative;
      @media screen and (min-width: $tablet) {
        &:hover {
          td:first-of-type:before,
          td:last-of-type:before {
            content: '';
            display: block;
            position: absolute;
            left: -5px;
            top: 0;
            width: 5px;
            height: 100%;
            background-color: #ff0000;
          }
          td:last-of-type:before {
            right: -5px;
            left: auto;
          }
        }
      }
      &.selected {
        .button.is-success {
          background-color: transparent;
          border-color: #4a4a4a;
          color: #4a4a4a;
        }
      }
      img {
        max-height: 25px;
        vertical-align: middle;
      }
      td {
        @media screen and (max-width: $tablet) {
          &.action-icon {
            position: absolute;
            right: 0;
            top: 0;
          }
        }
        button,
        .button {
          padding: 0 30px;
          vertical-align: middle;
          font-weight: 700;
          font-size: 14px;
          border-radius: 0;
          line-height: 1;
          padding: 0 10px;
        }
        position: relative;
        vertical-align: middle;
        line-height: 1;
        span.icon {
          position: relative;
          cursor: pointer;
          &.settings.is-active .settings {
            display: initial;
          }
          .settings {
            -webkit-animation-duration: 0.3s;
            animation-duration: 0.3s;
            min-width: 250px;
            display: none;
            position: absolute;
            top: 30px; // left: 0px;
            background-color: #fff; // list-style: none;
            // padding:10px 20px;
            // margin: 0;
            z-index: 100;
            @media screen and (max-width: $tablet) {
              right: 0;
            }
          }
          > i {
            padding: 10px;
            &.fa-cog {
              &:hover {
                animation-name: rotate;
                animation-duration: 1s;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '../../assets/css/variables';

.modal {
  input {
    border: 1px solid;
    box-shadow: none !important;
    border-radius: 3px;
    padding: 0 20px;
  }

  div.tabs {
    margin: 0;

    ul {
      margin: 0;
      padding: 0;
      width: 100%;
    }
  }

  .modal-content {
    text-align: center;
  }

  .modal-footer {
    padding: 20px;
    height: 85px;
  }

  div.relative {
    position: relative;
  }

  div#dateRangeHolder {
    margin: 10px auto;
    width: 870px;

    @media screen and (max-width: $desktop - 1px) {
      width: 560px;
    }

    @media screen and (max-width: $tablet - 1px) {
      width: 255px;
    }

    div.datePickerLabel {
      float: left;
      margin-right: 8px;
      height: 36px;
      line-height: 36px;
      font-weight: 900;
      width: 90px;
      width: auto;
    }

    div.flatpickr-wrapper {
      float: left !important;
      margin-right: 40px !important;
    }

    div.datepickerContainer {
      float: left !important;
      margin-right: 40px !important;
      @media screen and (max-width: $desktop - 1px) {
        width: 125px !important;
        margin-right: 15px !important;
      }
    }

    div.block {
      float: left;
      margin-right: 40px;
      margin-bottom: 0px;

      @media screen and (max-width: $desktop - 1px) {
        margin-right: 15px !important;
      }
    }
  }
}
.archived {
  color: $grey-light;
}
.custom-linked-taid {
  text-decoration: underline;
  &:hover {
    color: $primary;
  }
}

[data-fsval-errorplaceholder] {
  display: none;
}

@media screen and (max-width: $desktop - 1px) {
  .tradesTable {
    line-height: 1.2;
    margin-top: 15px;
    font-size: 13px;

    thead > tr > th {
      font-size: 13px;
      padding: 7px;
    }

    tbody > tr > td {
      font-size: 13px;
      padding: 7px;
    }
  }
}

@media screen and (max-width: $mobile) {
  .modal .modal-card {
    width: 100vw;
    height: 100vh;
  }
}
</style>



// WEBPACK FOOTER //
// ListAccounts.vue?1abb3b37